// extracted by mini-css-extract-plugin
export var container = "BottomTray-module__container___rkJpA";
export var opacScreen = "BottomTray-module__opacScreen___BdDCk";
export var tray = "BottomTray-module__tray___Hxr1Q";